import React from 'react';
import MembershipCrawlSearchTemplate from '../../components_membership_hotel/template/hotel/membershipCrawlSearchTemplate';
import { getReserveList, getVacancy2Month, getSenyuNenList } from '../../const';
import image_base from '../../resources/image/HakoneGardenTerrace.jpg';
import common from '../../resources/js/common/common';
import commonUtil from '../../common/commonUtil';
// import { confirmHotelReservation, getFavoriteCondition } from "../../const";

class MembershipCrawlSearch extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // 検索条件保存モーダル
            membershipPopup: false,
            // カレンダーモーダル
            calendarPopup: false,
            // チェックリストモーダル
            checkListPopup: false,
            // 会員モーダル
            crawlPopup: false,
            crawlPopupMode: "",
            // 占有日モーダル
            senyuubiPopup: false,
            shokaKenriNenList: [],
            // 「ホームFLとは」モーダル
            descHomeFlPopup: false,
            // レストラン空き状況照会モーダル
            restaurantVacancyPopup: false,
            restaurantInfo: {},
            restaurantVacancyInfo: [],
            // プラン検索フラグ
            searchPlanFlg: false,
            // 施設カレンダーモーダル
            facilityCalendarPopup: false,
            // 施設空室状況情報
            facilityVacancyInfo: {
                facilityId: "",
                facilityName: "",
                facilityTel: "",
                vacancyDateList: []
            },
            // カレンダー検索条件
            searchVacancyParam: {
                keiyakuNo: "",
                roomGradeList: [],
                startDate: "",
                shisetsuCdList: [],
                roomCnt: 0,
                guestCnt: 0,
                riyoKaiinKenSbtKbn: ""
            },
            // 部屋詳細モーダル
            roomDetailPopup: false,
            roomInfo: {},
            // 施設ID
            facilityId: "",
            // ポップアップ用施設空室状況情報
            vacancyInfo: [],
            // 予約確認モーダル
            membershipReservationConfPopup: false,
            // 予約キャンセルモーダル
            membershipReservationCancelPopup: false,
            // ローディング画面表示フラグ
            loadingFlg: false
        };
    };

    render() {

        const style = {
            base: {
                backgroundImage: `url(${image_base})`,
                backgroundAttachment: "fixed",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
            },
        }

        // 予約情報取得後処理
        const afterConfirmHotelReservation = (res) => {
            const data = res.data;
            if (data.resultCode !== 0) {

            } else {
                this.setState(
                    {
                        popupDataList: res.data.reserve,
                    }
                );
            }
        }

        // カレンダーモーダル
        const onClickOpenCalendarWindow = (e) => {
            this.setState({ calendarPopup: !this.state.calendarPopup });
            let checkInFlg = false;
            let checkOutFlg = false;
            let title = "";
            if (e !== undefined) {
                if (e.target.id === 'checkIn') {
                    checkInFlg = true;
                    checkOutFlg = false;
                    title = "チェックイン"
                }
                else if (e.target.id === 'checkOut') {
                    checkInFlg = false;
                    checkOutFlg = true;
                    title = "チェックアウト"
                }
                this.setState(
                    {
                        checkInFlg: checkInFlg,
                        checkOutFlg: checkOutFlg,
                        popupTitle: title
                    }
                );
            }
        }

        // 施設カレンダーモーダル
        const onClickOpenFacilityCalendarWindow = (req, name, dispStartDate) => {
            this.setState(
                {
                    facilityCalendarPopup: !this.state.facilityCalendarPopup,
                    calendarStartDate: dispStartDate,
                    facilityId: req.shisetsuCdList[0] ? req.shisetsuCdList[0] : "",
                    facilityCalendarFlg: true,
                    popupFacilityName: name ? name : ""
                }
            );
            // カレンダー検索用検索情報取得
            req.startDate = commonUtil.getStringFromDate(req.startDate, "yyyy-MM-dd"); //日付をフォーマット
            common.doPost(getVacancy2Month, req, afterGetVacancy2Month);
        }

        // チェックリストモーダル
        const onClickOpenCheckListWindow = (e) => {
            this.setState({ checkListPopup: !this.state.checkListPopup });
            let facilityFlg = false;
            let detailCriteriaFlg = false;
            let gradeFlg = false;
            let roomDetailCriteriaFlg = false;
            let title = "";
            if (e !== undefined) {
                if (e.target.id === 'facility') {
                    facilityFlg = true;
                    detailCriteriaFlg = false;
                    gradeFlg = false;
                    title = "エリア・ホテル"
                } else if (e.target.id === 'detailCriteria') {
                    facilityFlg = false;
                    detailCriteriaFlg = true;
                    gradeFlg = false;
                    title = "詳細条件"
                } else if (e.target.id === 'grade') {
                    facilityFlg = false;
                    detailCriteriaFlg = true;
                    title = "グレード"
                    gradeFlg = true;
                } else if (e.target.id === 'roomDetailCriteria') {
                    facilityFlg = false;
                    detailCriteriaFlg = false;
                    title = "部屋詳細条件"
                    gradeFlg = false;
                    roomDetailCriteriaFlg = true;
                }
                this.setState(
                    {
                        facilityFlg: facilityFlg,
                        detailCriteriaFlg: detailCriteriaFlg,
                        popupTitle: title,
                        gradeFlg: gradeFlg,
                        roomDetailCriteriaFlg: roomDetailCriteriaFlg
                    });
            }
        }

        // カレンダー検索用検索情報取得
        const onClickCalendarMove = (req) => {
            // カレンダー検索用検索情報取得
            common.doPost(getVacancy2Month, req, afterGetVacancy2Month);
        }
        // カレンダー検索用検索情報取得後処理
        const afterGetVacancy2Month = (res) => {
            const data = res.data;
            if (data.resultCode == 0) {
                let shisetsuCd = "";
                let shisetsuName = "";
                let shisetsuTel = "";
                let facilityVacancyList = [];
                data.kushitsuList.forEach((value, index) => {
                    if (index === 0) {
                        shisetsuCd = value.shisetsuCd;
                        shisetsuName = value.shisetsuName;
                        shisetsuTel = value.shisetsuTel;
                        facilityVacancyList = value.kushitsuDateList;
                    }
                })
                this.setState({
                    facilityVacancyInfo: {
                        facilityId: shisetsuCd,
                        facilityName: shisetsuName,
                        facilityTel: shisetsuTel,
                        vacancyDateList: facilityVacancyList
                    }
                });
            }
        }

        // 会員モーダル
        const onClickOpenCrawlWindow = (mode) => {
            this.setState({ crawlPopup: !this.state.crawlPopup, crawlPopupMode: mode  });
            let facilityFlg = false;
            let detailCriteriaFlg = false;
            let title = "CRAWL";
            this.setState(
                {
                    facilityFlg: facilityFlg,
                    detailCriteriaFlg: detailCriteriaFlg,
                    popupTitle: title
                });
        }

        // 占有日モーダル
        const onClickOpenSenyuubiWindow = (keiyakuNo) => {
            common.doPost(getSenyuNenList, { keiyakuNo: keiyakuNo }, afterGetSenyuNenList);
        }

        // 「ホームFlとは」モーダル
        const onClickOpenDescriptionHomeFlWindow = () => { this.setState({ descHomeFlPopup: true }); };

        // 占有日一覧取得後処理
        const afterGetSenyuNenList = (res) => {
            const data = res.data;
            if (data.resultCode == 0) {
                this.setState({ 
                    senyuubiPopup: true,
                    shokaKenriNenList: data.shokaKenriNenList
                });
            } else {
                this.setState({ 
                    senyuubiPopup: true,
                    shokaKenriNenList: []
                });
            }
        }

        // レストラン空き状況照会モーダル
        const onClickOpenRestaurantVacancyPopup = (restaurantVacancyInfo, restaurantInfo, riyoDate) => {
            this.setState({ restaurantVacancyPopup: true, restaurantVacancyInfo: restaurantVacancyInfo, restaurantInfo: restaurantInfo, riyoDate: riyoDate });
        }

        // ポップアップ用施設空室状況情報設定
        const setVacancyInfo = (list) => { this.setState({ vacancyInfo: list }); };

        // モーダルを閉じる
        const onClickClosePopupWindow = () => { this.setState({ membershipPopup: false, crawlPopup: false }); };

        // 占有日モーダルを閉じる
        const onClickCloseSenyuubiPopupWindow = () => { this.setState({ senyuubiPopup: false}); };

        // 「ホームFlとは」モーダルを閉じる
        const onClickCloseDescriptionHomeFlWindow = () => { this.setState({ descHomeFlPopup: false }); };

        // レストラン空き状況照会モーダルを閉じる
        const onClickCloseRestaurantVacancyPopup = () => { this.setState({ restaurantVacancyPopup: false}); };

        // 予約確認モーダル
        const onClickOpenReservationPopupWindow = (pointKaiinId) => {
            this.setState({ membershipReservationConfPopup: true, loadingFlg: true });
            common.doPost(getReserveList, { pointKaiinId: pointKaiinId }, afterGetReserveList);
        }
        // 予約情報取得後処理
        const afterGetReserveList = (res) => {
            let data = res.data;
            if (data.resultCode == 0) {
                this.setState({ reservationConfList: res.data, });
            }
            this.setState({ loadingFlg: false });
        }

        // カレンダー検索条件設定
        const setSearchVacancyParam = (param) => {
            this.setState({
                searchVacancyParam: param
            })
        }

        // 部屋詳細ポップアップ表示
        const onClickOpenRoomDetailPopup = (room) => {
            this.setState({
                roomDetailPopup: true,
                roomInfo: room,
            });
        }

        // 予約確認モーダルを閉じる
        const onClickCloseReservationConfPopupWindow = () => { this.setState({ membershipReservationConfPopup: false }); };
        // 施設カレンダーモーダル
        const onClickCloseFacilityCalendarWindow = () => { this.setState({ facilityCalendarPopup: false }); }
        // キャンセルモーダル
        const onClickOpenCancelPopupWindow = () => {
            this.setState({ membershipReservationCancelPopup: true });
        }
        // キャンセルモーダルClose
        const onClickCloseCancelPopupWindow = () => {
            this.setState({ membershipReservationCancelPopup: false });
        };
        // 部屋詳細モーダルClose
        const onClickCloseRoomDetailPopup = () => { this.setState({ roomDetailPopup: false }); };
        return (
            <div style={style.base}>
                <MembershipCrawlSearchTemplate
                    state={this.state}
                    onClickOpenCalendarWindow={onClickOpenCalendarWindow}
                    onClickOpenCheckListWindow={onClickOpenCheckListWindow}
                    onClickOpenCrawlWindow={onClickOpenCrawlWindow}
                    onClickClosePopupWindow={onClickClosePopupWindow}
                    onClickOpenSenyuubiWindow={onClickOpenSenyuubiWindow}
                    onClickCloseSenyuubiPopupWindow={onClickCloseSenyuubiPopupWindow}
                    onClickOpenDescriptionHomeFlWindow={onClickOpenDescriptionHomeFlWindow}
                    onClickCloseDescriptionHomeFlWindow={onClickCloseDescriptionHomeFlWindow}
                    onClickOpenFacilityCalendarWindow={onClickOpenFacilityCalendarWindow}
                    onClickCloseFacilityCalendarWindow={onClickCloseFacilityCalendarWindow}
                    onClickCalendarMove={onClickCalendarMove}
                    onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                    onClickCloseReservationConfPopupWindow={onClickCloseReservationConfPopupWindow}
                    onClickOpenCancelPopupWindow={onClickOpenCancelPopupWindow}
                    onClickCloseCancelPopupWindow={onClickCloseCancelPopupWindow}
                    onClickOpenRoomDetailPopup={onClickOpenRoomDetailPopup}
                    onClickCloseRoomDetailPopup={onClickCloseRoomDetailPopup}
                    onClickOpenRestaurantVacancyPopup={onClickOpenRestaurantVacancyPopup}
                    onClickCloseRestaurantVacancyPopup={onClickCloseRestaurantVacancyPopup}
                    setVacancyInfo={setVacancyInfo}
                    setSearchVacancyParam={setSearchVacancyParam}
                />
            </div>
        )
    }
}
export default MembershipCrawlSearch;
